import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { projects } from "../data/site";
import { Reveal } from "../components/Reveal";

export default function Projects() {
  return (
    <div data-testid="projects-page" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">Projeler</span>
        </div>

        <div className="mb-16 max-w-3xl">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
            Referanslar
          </div>
          <h1 className="font-serif-display text-4xl md:text-6xl lg:text-7xl text-[#1E1E1E] leading-tight">
            Mekânlarımızın günlüğü.
          </h1>
          <p className="mt-5 text-[15px] text-[#666] max-w-lg leading-relaxed">
            Türkiye'nin dört bir yanındaki villalar, oteller ve ofis kuleleri —
            SeraPark'ın kürasyonuyla imzalanan seçili projeler.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {projects.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <div
                data-testid={`project-item-${p.slug}`}
                className="break-inside-avoid group"
              >
                <div
                  className={`clip-frame overflow-hidden ${
                    p.height === "tall"
                      ? "aspect-[3/4]"
                      : p.height === "short"
                      ? "aspect-[4/3]"
                      : "aspect-[1/1]"
                  }`}
                >
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover img-zoom"
                  />
                </div>
                <div className="pt-5">
                  <div className="text-[10px] tracking-[0.25em] uppercase text-[#B8860B]">
                    {p.location} · {p.year}
                  </div>
                  <h3 className="mt-1 text-xl font-medium text-[#1E1E1E]">
                    {p.title}
                  </h3>
                  <div className="mt-3 flex gap-2 flex-wrap">
                    {p.tags.map((t) => (
                      <span
                        key={t}
                        className="text-[10px] tracking-wider uppercase text-[#888] border border-[#1E1E1E]/15 px-2 py-1"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
